
import {parse} from 'envfile';
import {Compare} from "@/helpers/common";
import Vue from 'vue';
import {Diff} from "@/types";
import Component from "vue-class-component";

@Component({
  components: {
    DiffChecker
  }
})
export default class DiffChecker extends Vue {
  firstInput: string = '';
  secondInput: string = '';
  diff: Diff[] = []

  async mounted(): Promise<void> {
    await fetch('first.txt')
      .then(response => response.text())
      .then((response) => {
        this.firstInput = response;
      })

    await fetch('second.txt')
      .then(response => response.text())
      .then((response) => {
        this.secondInput = response;
      })

    this.compare();
  }

  compare(): void {
    let compare = new Compare(parse(this.firstInput), parse(this.secondInput));

    this.diff = compare.getInformation();
  }
}
